import React, { useEffect, useState } from 'react';
import ExpenseField from './ExpenseField';


const AddExpense = () => {
     return (
        <div className='mx-auto p-2 mt-8'>
            <h1 className='text-md text-center bg-primary p-3 text-white rounded-xl'>Add An Expense</h1>
            <ExpenseField></ExpenseField>
        </div>
    );
};

export default AddExpense;